import {
  IS_FETCHING,
  IS_ERROR,
  IS_SUCCESS,
  SET_DROPDOWN_CATEGORIES,
} from "./actionsTypes";

import { getCategories } from "./services";
import { getErrorMessageFromRequestError } from "../../helpers/messages/request";

export const GET_DROPDOWN_CATEGORIES = (categories) => ({
  type: SET_DROPDOWN_CATEGORIES,
  payload: { categories },
});

export const SET_SUCCESS = ({ isSuccess }) => ({
  type: IS_SUCCESS,
  payload: { isSuccess },
});

const SET_FETCHING = ({ isFetching }) => ({
  type: IS_FETCHING,
  payload: { isFetching },
});

export const SET_ERROR = ({ isError, message }) => ({
  type: IS_ERROR,
  payload: { isError, message },
});

export const asyncGetDropdownCategories = () => async (dispatch) => {
  dispatch(SET_FETCHING({ isFetching: true }));
  dispatch(
    SET_ERROR({
      isError: false,
    })
  );
  dispatch(SET_SUCCESS({ isSuccess: false }));
  try {
    const response = await getCategories();
    if (response.status === 200) {
      dispatch(SET_SUCCESS({ isSuccess: true }));
      dispatch(GET_DROPDOWN_CATEGORIES(response.data.data));
    }
  } catch (error) {
    const message = getErrorMessageFromRequestError(error);
    dispatch(SET_SUCCESS({ isSuccess: false }));

    dispatch(
      SET_ERROR({
        isError: true,
        message,
      })
    );
  } finally {
    dispatch(SET_FETCHING({ isFetching: false }));
  }
};
